import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import MySchedule from './views/MySchedule.vue'
import ScheduleDetails from './views/ScheduleDetails.vue'

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'Login',
		component: Login
	},{
		path: '/myschedule',
		name: 'myschedule',
		component: MySchedule
	},{
		path: '/scheduledetails',
		name: 'scheduledetails',
		component: ScheduleDetails
	}]
})